import { FormCreationFormModal } from "@/components/form-creation-form";
import { MailboxTable } from "@/components/mailbox-table";
import { Button } from "@/components/ui/button";
import { createFileRoute } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import * as React from "react";

export const Route = createFileRoute(
  "/(dashboard)/_authenticated/$companyId/my-mailbox",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { companyId } = Route.useParams();
  const [open, setOpen] = React.useState(false);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Mis comunicaciones HSE</h1>
        <Button
          variant="default"
          onClick={() => setOpen(true)}
          className="flex items-center gap-2"
        >
          <Plus className="h-4 w-4" /> Nueva comunicación
        </Button>
      </div>

      <MailboxTable mode="user" />

      <FormCreationFormModal
        open={open}
        onOpenChange={setOpen}
        formType="mailbox"
        companyId={companyId}
        teamId=""
      />
    </div>
  );
}
